import { CheckIcon } from "@heroicons/react/solid";
import React from "react";
import { useParams } from "react-router-dom";
import Contact from "./Contact";
import { campaigns } from "../data";
import { trackEvent } from "../analytics";

const stats = [
  { label: "15+ Years", detail: "Engineering Experience" },
  { label: "Java · Spring · React", detail: "Core Stack" },
  { label: "UK-Based", detail: "Cambridge, UK" },
];

export default function CampaignLanding() {
  const { slug } = useParams();
  const campaign = campaigns[slug];

  if (!campaign) {
    return (
      <section className="bg-white text-gray-900">
        <div className="container px-5 py-16 mx-auto max-w-3xl text-center">
          <h1 className="text-3xl font-bold title-font mb-4">
            Page not found
          </h1>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="bg-purple-900 text-white">
        <div className="container mx-auto px-5 py-20 md:py-28 text-center max-w-3xl">
          <p className="text-purple-300 text-xs uppercase tracking-widest font-semibold mb-4">
            For {campaign.segment}
          </p>
          <h1 className="text-4xl sm:text-5xl font-bold title-font mb-6">
            {campaign.headline}
          </h1>
          <p className="text-lg text-purple-200 leading-relaxed mb-8">
            {campaign.subheadline}
          </p>
          <a
            href="#contact"
            onClick={() =>
              trackEvent("cta_click", { location: `campaign_${slug}_hero` })
            }
            className="inline-flex text-white bg-purple-500 border-0 py-3 px-8 hover:bg-purple-400 rounded-full text-lg font-medium"
          >
            Book Your Free Clarity Call
          </a>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-14">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="bg-purple-800 border border-purple-700 rounded-xl px-4 py-3"
              >
                <p className="font-bold title-font">{stat.label}</p>
                <p className="text-purple-300 text-xs mt-1">{stat.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white text-gray-900">
        <div className="container mx-auto px-5 py-16 max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold title-font mb-6">
              Sound familiar?
            </h2>
            <ul className="space-y-4">
              {campaign.painPoints.map((point) => (
                <li key={point} className="flex gap-3 text-gray-700">
                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-purple-500 flex-shrink-0" />
                  {point}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="text-2xl font-bold title-font mb-6">
              {campaign.valuePropsTitle}
            </h2>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {campaign.valueProps.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-2 text-sm text-gray-700"
                >
                  <CheckIcon className="w-5 h-5 text-purple-600 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <Contact />
    </>
  );
}
